import InformationField from './InformationField'

export default InformationField
